export const aluminiumSuppliers = [
  "Alspec",
  "Ezial",
  "Darley",
  "Capral",
  "AWS",
];
